if (!customElements.get('site-header')) {
  class SiteHeader extends HTMLElement {
  
    constructor() {
      super();
      this.init();
    }
  
    init() {
      this.body = document.body;
  
      this.mq = window.matchMedia('(max-width: 749px)');
  
      this.menuToggle = this.querySelector('.js-header-menu-toggle');
      this.searchToggle = this.querySelector('.js-header-search-toggle');
      this.searchInput = document.querySelector('.js-header-search-input');
      this.cartToggle = this.querySelector('.js-header-cart-toggle');
      this.languageDropdownToggle = this.querySelector('.js-header-language-dropdown-toggle');
      this.close = this.querySelector('.js-header-close');
      this.backdrop = document.querySelector('.js-backdrop');
      this.siteMenu = document.querySelector('.js-site-menu');
  
      this.menuToggle?.addEventListener('click', this.toggleMenu.bind(this));
      this.searchToggle?.addEventListener('click', this.showSearch.bind(this));
      this.cartToggle?.addEventListener('click', this.toggleCart.bind(this));
      this.backdrop?.addEventListener('click', this.clear.bind(this));
      this.close?.addEventListener('click', this.clear.bind(this));
      this.languageDropdownToggle?.addEventListener('click', this.toggleLanguageDropdown.bind(this));
  
      this.resizeChecker(this.mq);
      this.mq.addListener(this.resizeChecker.bind(this));
    }
  
    resizeChecker(mq) {
      if (mq.matches) {
        this.body.classList.remove('language-dropdown-active');
      }
    }
  
    closeMenu() {
      this.body.classList.remove('menu-active');
      const menuToggles = document.querySelectorAll('.js-site-menu-toggle');
  
      menuToggles.forEach((el) => {
        el.classList.remove('level-2-active');
        el.classList.remove('level-3-active');
      })
  
      this.siteMenu.classList.remove('site-menu--level-2-active');
      this.siteMenu.classList.remove('site-menu--level-3-active');
    }
  
    showSearch() {
      this.closeMenu();
      this.closeCart();
      this.closeLanguageDropdown();
      this.body.classList.add('menu-active');
      this.searchInput?.focus();
    }
  
    closeSearch() {
      this.searchInput?.blur();
      this.body.classList.remove('menu-active');
    }
  
    closeCart() {
      this.body.classList.remove('cart-active');
    }
    
    toggleMenu() {
      this.closeSearch();
      this.closeCart();
      this.closeLanguageDropdown();
      this.body.classList.toggle('menu-active');
    }
  
    toggleLanguageDropdown() {
      this.closeMenu();
      this.closeSearch();
      this.closeCart();
      this.body.classList.toggle('language-dropdown-active');
    }
  
    toggleCart() {
      this.closeMenu();
      this.closeSearch();
      this.closeLanguageDropdown();
      this.body.classList.toggle('cart-active');
    }
  
    closeLanguageDropdown() {
      this.body.classList.remove('language-dropdown-active');
    }
  
    clear() {
      this.closeMenu();
      this.closeSearch();
      this.closeCart();
      this.closeLanguageDropdown();
    }
  }

  customElements.define('site-header', SiteHeader);
}

if (!customElements.get('site-menu')) {
  class SiteMenu extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    
    init() {
      const toggles = this.querySelectorAll('.js-site-menu-toggle');
  
      toggles.forEach((toggle) => {
        const level = toggle.getAttribute('data-show-level');
  
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          this.resetScroll();
  
          toggle.classList.add(`level-${level}-active`);
          this.classList.add(`site-menu--level-${level}-active`);
        })
      });
  
      const backButtons = this.querySelectorAll('.js-site-menu-back');
  
      backButtons.forEach((button) => {
        const level = button.getAttribute('data-hide-level');
  
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.resetScroll();
  
          const openLevels = this.querySelectorAll(`.level-${level}-active`);
          
          openLevels.forEach((openlevel) => {
            openlevel.classList.remove(`level-${level}-active`);
          })
  
          this.classList.remove(`site-menu--level-${level}-active`);
        })
      });
    }
  
    resetScroll() {
      const levels = this.querySelectorAll('.js-site-menu-level');
      
      levels.forEach((level) => {
        level.scrollTop = 0;
      })
    }
  }
  
  customElements.define('site-menu', SiteMenu);
}

if (!customElements.get('language-dropdown')) {
  class LanguageDropdown extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
  
    init() {
      const form  = this.querySelector('.js-language-dropdown-form');
  
      form.addEventListener('keydown', (e) => {
        
        if (e.key === 'Enter') {
          e.preventDefault();
          form.submit();
        }
      })
  
      form?.addEventListener('click', (e) => {
        if (e.target.tagName !== 'INPUT') return;
  
        form.submit();
      })
    }
  }
  
  customElements.define('language-dropdown', LanguageDropdown);
}
